export enum ApiResponseCodeEnum {
  user_error = 400,
  invalid_token = 401,
  permission_denied = 403,
  server_error = 500,
}
